/**
 * Created by JasonChou on 16/6/6.
 */

import {TEST} from '../mutationTypes'

const state = {
  content: 'fggg'
};

//wsdk.set('test', state);

// mutations
const mutations = {
  [TEST] (state, input) {
    state.content = input;
  }
};

export default {
  state,
  mutations
}



/** WEBPACK FOOTER **
 ** ./src/store/modules/test.js
 **/